<template>
    <button
        :id="id"
        :class="buttonClasses"
        v-on="$listeners"
    >
        <slot />
    </button>
</template>

<script>
// Types
import {
    buttonColors,
    defaultButtonColor,
    buttonVariants,
    defaultButtonVariant,
    buttonWidth,
    defaultButtonWidth,
    buttonHeight,
    defaultButtonHeight
} from '../types/Button.types';

// Mixins
import styles from '../mixins/styles.js';

// Utils
import { eligibleProp } from '../utils/props-utils.js';

export default {
    name: 'Button',
    mixins: [styles],
    props: {
        alignmentMarginTop: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: defaultButtonWidth,
            validator: eligibleProp(buttonWidth)
        },
        height: {
            type: String,
            default: defaultButtonHeight,
            validator: eligibleProp(buttonHeight)
        },
        color: {
            type: String,
            default: defaultButtonColor,
            validator: eligibleProp(buttonColors)
        },
        variant: {
            type: String,
            default: defaultButtonVariant,
            validator: eligibleProp(buttonVariants)
        },
        id: {
            type: String,
            default: ''
        }
    },
    computed: {
        buttonClasses: function() {
            return [
                this.cssClasses.pcc__buttonComponent,
                this.alignmentMarginTop && this.cssClasses.pcc__buttonComponent_alignment_mt_2,
                this.width && this.cssClasses[`pcc__buttonComponent_${this.width}`],
                this.height && this.cssClasses[`pcc__buttonComponent_${this.height}`],
                this.cssClasses[`pcc__buttonComponent_${this.variant}Variant`],
                this.cssClasses[`pcc__buttonComponent_${this.color}Color`],
            ]
        }
    },
};
</script>
